export default __webpack_public_path__ + "static/media/logo.4e44b06c.svg";